import { functionNodeSchemaWithDeprecated } from '../../dsl/syntax/expression_ast.ts'
import type { ModelProperty } from '../../schemas/model/modelProperty.ts'

export function isRequiredProperty(property: ModelProperty): boolean {
  // カスタムオブジェクトの「入力を必須化」は、真偽値も含めて必須扱いにする
  if (property.required === true) {
    return true
  }
  // やや手抜き
  if (property.type === 'boolean') {
    // Salesforce の真偽値は、入力しなくてもレコードの作成ができてしまうので非必須扱いとする: https://github.com/salescore-inc/issues/issues/881
    // この条件だと他のデータソースでも真偽値なら非必須扱いになってしまう。必要なら Salesforce だけに適用する。
    return false
  }
  return (property.validations ?? []).some((v) => {
    const parsed = functionNodeSchemaWithDeprecated.safeParse(v.function)
    if (!parsed.success) {
      return false
    }
    const { type } = parsed.data
    switch (type) {
      case 'func': {
        return parsed.data.name === 'present'
      }
      case 'function': {
        return parsed.data.functionType === 'present'
      }
      // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
      default: {
        return false
      }
    }
  })
}
